"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _presetHtml5 = /*#__PURE__*/ _interopRequireDefault(require("@bbob/preset-html5"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _tags, _tags1, _tags2, _tags3;
var tagAttr = function(style) {
    return {
        attrs: {
            style: style
        }
    };
};
var _default = _presetHtml5.default.extend(function(tags) {
    return _extends({}, tags, {
        b: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _extends({}, (_tags = tags).b.apply(_tags, args), tagAttr({
                fontWeight: "bold"
            }));
        },
        i: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _extends({}, (_tags1 = tags).i.apply(_tags1, args), tagAttr({
                fontStyle: "italic"
            }));
        },
        u: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _extends({}, (_tags2 = tags).u.apply(_tags2, args), tagAttr({
                textDecoration: "underline"
            }));
        },
        s: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _extends({}, (_tags3 = tags).s.apply(_tags3, args), tagAttr({
                textDecoration: "line-through"
            }));
        }
    });
});
